import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { IndianRupee, TrendingUp } from "lucide-react";
import { Skeleton } from "./ui/skeleton";

export const ProductCatalog = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/products")
      .then((r) => setProducts(r.data))
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section id="products" data-testid="products-section" className="section-pad bg-[#FAFAF9]">
      <div className="container-x">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#C2410C]">Catalog</div>
            <h2 className="font-display mt-3 text-3xl sm:text-5xl font-black text-[#064E3B] tracking-tight">
              Everyday essentials your neighbourhood already buys
            </h2>
          </div>
          <div className="bg-white border border-[#E7E5E4] rounded-2xl px-5 py-4">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#57534E]">Average margin</div>
            <div className="font-display text-3xl font-black text-[#064E3B]">40 – 50%</div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {loading &&
            Array.from({ length: 8 }).map((_, i) => (
              <Skeleton key={i} className="h-80 rounded-2xl" />
            ))}

          {!loading &&
            products.map((p) => (
              <div
                key={p.id}
                data-testid={`product-card-${p.id}`}
                className="card-lift bg-white border border-[#E7E5E4] rounded-2xl overflow-hidden"
              >
                <div className="aspect-[4/3] bg-[#F5F5F4] overflow-hidden">
                  <img
                    src={p.image}
                    alt={p.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="p-5">
                  <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#C2410C]">
                    {p.category} · {p.size}
                  </div>
                  <h3 className="mt-2 font-display font-bold text-lg text-[#064E3B]">{p.name}</h3>
                  <p className="mt-1 text-xs text-[#57534E] line-clamp-2">{p.description}</p>

                  <div className="mt-4 flex items-end justify-between">
                    <div>
                      <div className="text-[10px] font-bold uppercase tracking-[0.15em] text-[#57534E]">
                        Your cost
                      </div>
                      <div className="flex items-center font-display text-2xl font-black text-[#064E3B]">
                        <IndianRupee className="h-5 w-5" />{p.wholesale}
                      </div>
                    </div>
                    <div className="text-right">
                      <div className="text-[10px] font-bold uppercase tracking-[0.15em] text-[#57534E]">MRP</div>
                      <div className="text-sm line-through text-[#78716C]">₹{p.mrp}</div>
                    </div>
                  </div>

                  <div className="mt-4 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-[#064E3B] text-white text-xs font-bold">
                    <TrendingUp className="h-3.5 w-3.5" /> Profit ₹{p.margin} / unit
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default ProductCatalog;
